import React from 'react';
import imgResolver from '../utils/img-resolver';
import ReactDatePicker from 'react-date-picker';
import moment from 'moment';

class DateRangePickerToggle extends React.Component {
    render () {
        const dateText = this.props.dateText;
        return (
            <div className="daterangepicker">
                <img className="daterangepicker-button" src={require('../styles/images/icon_calendar_gray.svg')} alt="Calendar" />
                <span className="selected-dates">{dateText}</span>

            </div>
        );
    }
}

class DateRangePickerSelectDates extends React.Component {

    constructor(props) {
        super(props);

        this.state = {startDate: moment(), endDate: moment()}
    }

    componentDidMount() {
        this.setState({
            startDate: this.props.dates.start,
            endDate: this.props.dates.end
        });
    }

    render() {
        return (
            <div className={"daterangepicker-overlay whitebox anim-popup" + (this.props.enabled ? " active" : "")}>
                <ReactDatePicker
                    defaultDate={Date.now()}
                    weekStartDay="1"
                    date={this.state.startDate}
                    onChange={this.setStartDate.bind(this)}
                    todayText="This month"
                    minDate={moment()}
                    gotoSelectedText="Selected month"
                    hideFooter
                        {...this.props} />
                <ReactDatePicker
                    defaultDate={Date.now()}
                    weekStartDay="1"
                    date={this.state.endDate}
                    onChange={this.setEndDate.bind(this)}
                    todayText="This month"
                    minDate={moment()}
                    gotoSelectedText="Selected month"
                    hideFooter
                        {...this.props} />
            </div>
        );
    }

    setStartDate(startDate) {
        let endDate = this.state.endDate;

        if (moment(endDate) <= moment(startDate)) {
            endDate = moment(startDate).add(1, "d");
        }

        this.setState({startDate, endDate});

        if (startDate !== '' && this.state.endDate !== '') {
            this.parentCallback(startDate, endDate);
        }
    }

    setEndDate(endDate) {
        let startDate = this.state.startDate;

        if (moment(endDate) <= moment(this.state.startDate)) {
            startDate = moment(endDate).add(-1, "d");
        }

        this.setState({startDate, endDate});

        if (this.state.startDate !== '' && endDate !== '') {
            this.parentCallback(startDate, endDate);
        }
    }

    parentCallback(startDate, endDate) {
        this.props.dateCallback(startDate, endDate);
    }
}

export default {DateRangePickerToggle, DateRangePickerSelectDates};



/** WEBPACK FOOTER **
 ** ./app/src/components/DateRangePickerModular.js
 **/